import {
  AuthenticationService,
  CareersService,
  ClassroomService,
  ConfigurationService,
  DisciplinesService,
  ImpactReportService,
  IntegrationService,
  LibraryService,
  MenuBuilderService,
  OrganizationService,
  ProgramsService,
  TrekService,
  UserService,
} from "./services";
import { LocalStorageCache } from "./utils/local-storage-cache";
import { parseStringBoolean } from "./utils/utils";

export const caches = {
  userCache: new LocalStorageCache("transfr:internal-portal:currentUser"),
  tokenCache: new LocalStorageCache("transfr:internal-portal:token"),
};

export const toggles = {
  isLibraryEnabled: parseStringBoolean(process.env.LIBRARY_ENABLED),
  vrCustomizationEnabled: parseStringBoolean(
    process.env.VR_CUSTOMIZATION_ENABLED,
  ),
  isProfessionalLearningEnabled: parseStringBoolean(
    process.env.PROFESSIONAL_LEARNING_ENABLED,
  ),
  isCurriculumResourcesEnabled: parseStringBoolean(
    process.env.CURRICULUM_RESOURCES_ENABLED,
  ),
};

export const services = {
  authenticationService: new AuthenticationService(
    process.env.DASHBOARD_API_URL,
    { publicPaths: ["/auth/login", "/auth/reset"] },
    caches,
  ),
  userService: new UserService(process.env.DASHBOARD_API_URL, {}, caches),
  organizationService: new OrganizationService(
    process.env.DASHBOARD_API_URL,
    {},
    caches,
  ),
  classroomService: new ClassroomService(
    process.env.DASHBOARD_API_URL,
    {},
    caches,
  ),
  disciplinesService: new DisciplinesService(
    process.env.DASHBOARD_API_URL,
    {},
    caches,
  ),
  careersService: new CareersService(process.env.DASHBOARD_API_URL, {}, caches),
  menuBuilderService: new MenuBuilderService(
    process.env.DASHBOARD_API_URL,
    {},
    caches,
  ),
  trekService: new TrekService(process.env.CESE_API_URL, {}, caches),
  programsService: new ProgramsService(
    process.env.DASHBOARD_API_URL,
    {},
    caches,
  ),
  impactReportService: new ImpactReportService(
    process.env.DASHBOARD_API_URL,
    {},
    caches,
  ),
  integrationService: new IntegrationService(
    process.env.DASHBOARD_API_URL,
    {},
    caches,
  ),
  configurationService: new ConfigurationService(
    `${process.env.DASHBOARD_BASE_URL}/config-service`,
    {},
    caches,
  ),
  libraryService: new LibraryService(process.env.DASHBOARD_API_URL, {}, caches),
};
